import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { UiCUserAccountInfoModule } from '@wlp/ui-c-user-account-info';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCUserCardMenuComponent = class UiCUserCardMenuComponent {
    constructor() {
        this.logout = new EventEmitter();
        this.myData = new EventEmitter();
        this.myFeesAndTariffs = new EventEmitter();
        this.isVisibleFeesAndTariffs = false;
        this.secundary = false;
    }
    onLogout() {
        this.logout.emit(true);
    }
    myDataEvent() {
        this.myData.emit();
    }
    myFeesAndTariffsEvent() {
        this.myFeesAndTariffs.emit();
    }
};
__decorate([
    Input()
], UiCUserCardMenuComponent.prototype, "flagDisplayCard", void 0);
__decorate([
    Input()
], UiCUserCardMenuComponent.prototype, "userProfile", void 0);
__decorate([
    Input()
], UiCUserCardMenuComponent.prototype, "qrCodeData", void 0);
__decorate([
    Output()
], UiCUserCardMenuComponent.prototype, "logout", void 0);
__decorate([
    Output()
], UiCUserCardMenuComponent.prototype, "myData", void 0);
__decorate([
    Output()
], UiCUserCardMenuComponent.prototype, "myFeesAndTariffs", void 0);
__decorate([
    Input()
], UiCUserCardMenuComponent.prototype, "backgroundImage", void 0);
__decorate([
    Input()
], UiCUserCardMenuComponent.prototype, "isVisibleFeesAndTariffs", void 0);
__decorate([
    Input()
], UiCUserCardMenuComponent.prototype, "secundary", void 0);
UiCUserCardMenuComponent = __decorate([
    Component({
        selector: 'ui-c-user-card-menu',
        template: "<div class=\"position-fixed card-position\" *ngIf=\"flagDisplayCard\">\n  <div class=\"dropdown-menu dropdown-menu-anim-up\">\n    <ion-card class=\"user-card\">\n      <ion-card-header class=\"user-card-header\" [style.background-image]=\"'url(' + backgroundImage + ')'\">\n        <ui-c-user-account-info [userProfile]=\"userProfile\" [qrCodeData]=\"qrCodeData\"></ui-c-user-account-info>\n      </ion-card-header>\n\n      <ion-item>\n        <ion-row class=\"card-user-row\">\n          <ion-col>\n            <p id=\"card-username-icon\" class=\"text-center font-weight-bold\">{{ userProfile?.nameInitials }}</p>\n          </ion-col>\n          <ion-col class=\"card-user-col\">\n            <p class=\"card-user-name\">{{ userProfile?.nameFirst }}</p>\n            <p class=\"card-user-email\">{{ userProfile?.email }}</p>\n          </ion-col>\n        </ion-row>\n      </ion-item>\n\n      <ion-card-content class=\"card-content\">\n        <ion-row class=\"content-row\" (click)=\"myDataEvent()\" *ngIf=\"secundary === false\">\n          <ion-col class=\"content-icon\" size=\"1\">\n            <ion-icon class=\"icon\" name=\"person-outline\"></ion-icon>\n          </ion-col>\n          <ion-col class=\"card-user-col\" size=\"10\">\n            <p class=\"card-content-title\">{{ 'DASHBOARD.USER_CARD_MENU.MY_ACCOUNT.TITLE' | wlpTranslate }}</p>\n            <p class=\"card-content-sub\">{{ 'DASHBOARD.USER_CARD_MENU.MY_ACCOUNT.SUBTITLE' | wlpTranslate }}</p>\n          </ion-col>\n          <ion-col class=\"content-icon\" size=\"1\">\n            <ion-icon class=\"icon\" name=\"chevron-forward-outline\"></ion-icon>\n          </ion-col>\n        </ion-row>\n        <ion-row class=\"content-row\" (click)=\"myFeesAndTariffsEvent()\" *ngIf=\"isVisibleFeesAndTariffs && secundary === false\">\n          <ion-col class=\"content-icon\" size=\"1\">\n            <ion-icon class=\"icon\" name=\"cash-outline\"></ion-icon>\n          </ion-col>\n          <ion-col class=\"card-user-col\" size=\"10\">\n            <p class=\"card-content-title\">{{ 'DASHBOARD.USER_CARD_MENU.FEES_TARIFFS.TITLE' | wlpTranslate }}</p>\n            <p class=\"card-content-sub\">{{ 'DASHBOARD.USER_CARD_MENU.FEES_TARIFFS.SUBTITLE' | wlpTranslate }}</p>\n          </ion-col>\n          <ion-col class=\"content-icon\" size=\"1\">\n            <ion-icon class=\"icon\" name=\"chevron-forward-outline\"></ion-icon>\n          </ion-col>\n        </ion-row>\n        <ion-row class=\"content-row\" *ngIf=\"false\">\n          <ion-col class=\"content-icon\" size=\"1\">\n            <ion-icon class=\"icon\" name=\"help-circle-outline\"></ion-icon>\n          </ion-col>\n          <ion-col class=\"card-user-col\" size=\"10\">\n            <p class=\"card-content-title\">{{ 'DASHBOARD.USER_CARD_MENU.HELP.TITLE' | wlpTranslate }}</p>\n            <p class=\"card-content-sub\">{{ 'DASHBOARD.USER_CARD_MENU.HELP.SUBTITLE' | wlpTranslate }}</p>\n          </ion-col>\n          <ion-col class=\"content-icon\" size=\"1\">\n            <ion-icon class=\"icon\" name=\"chevron-forward-outline\"></ion-icon>\n          </ion-col>\n        </ion-row>\n        <ion-row class=\"content-row\" *ngIf=\"false\">\n          <ion-col class=\"content-icon\" size=\"1\">\n            <ion-icon class=\"icon\" name=\"settings-outline\"></ion-icon>\n          </ion-col>\n          <ion-col class=\"card-user-col\" size=\"10\">\n            <p class=\"card-content-title\">{{ 'DASHBOARD.USER_CARD_MENU.SETTINGS.TITLE' | wlpTranslate }}</p>\n            <p class=\"card-content-sub\">{{ 'DASHBOARD.USER_CARD_MENU.SETTINGS.SUBTITLE' | wlpTranslate }}</p>\n          </ion-col>\n          <ion-col class=\"content-icon\" size=\"1\">\n            <ion-icon class=\"icon\" name=\"chevron-forward-outline\"></ion-icon>\n          </ion-col>\n        </ion-row>\n        <ion-row class=\"content-row\" (click)=\"onLogout()\" >\n          <ion-col class=\"content-icon-logout\" size=\"1\">\n            <ion-icon class=\"icon\" name=\"log-out-outline\"></ion-icon>\n          </ion-col>\n          <ion-col class=\"card-user-col-logout\" size=\"10\">\n            <a class=\"card-content-title\">{{ 'DASHBOARD.USER_CARD_MENU.EXIT' | wlpTranslate }}</a>\n          </ion-col>\n          <ion-col class=\"content-icon-logout\" size=\"1\">\n            <ion-icon class=\"icon\" name=\"chevron-forward-outline\"></ion-icon>\n          </ion-col>\n        </ion-row>\n      </ion-card-content>\n    </ion-card>\n  </div>\n</div>\n"
    })
], UiCUserCardMenuComponent);

let UiCUserCardMenuModule = class UiCUserCardMenuModule {
};
UiCUserCardMenuModule = __decorate([
    NgModule({
        declarations: [UiCUserCardMenuComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            IonicModule,
            UiCUserAccountInfoModule,
            UiBsTranslateModule
        ],
        exports: [UiCUserCardMenuComponent]
    })
], UiCUserCardMenuModule);

/*
 * Public API Surface of ui-c-user-card-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCUserCardMenuComponent, UiCUserCardMenuModule };
//# sourceMappingURL=wlp-ui-c-user-card-menu.js.map
